<template>
	<section class="wall_dep deposit_and_withdrowl_sec">
        <div class="add_account_btn_title">
            <div class="back_to_amount">
                <a @click="$router.back(-1)" class="back-btn-lef">
                    <img src="@/assets/images/left-arrow-bg.webp" alt="left-arrow"  loading="lazy"/>
                    {{$t('back','Back')}}
                </a>
            </div>
            <button type="button" class="minMax-value"> 
                {{ $t('min', 'Min') }}: {{ minAmount }} | {{ $t('max', 'Max') }}: {{ maxAmount }}
            </button>
        </div>
			<div class="deposit_wrapper">
				<div class="amount-div">
					<div class="card-body depo-rgt-container amount_container_cl">
						<form id="amountForm" class="online-form-int" method="post">
							<div class="form-group " >
								<label class="wallet_label_name mb-1">Deposit Amount</label>
								<div class="amount_input_cl">
                                    <input type="number" :placeholder="$t('enter-amt', 'Enter Amount')"  @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.deposit_range?.max || 99999999)" v-model="amount" class="form-control">
								</div>
							</div>
                            <div class="amount-select-box"  v-if="walletConfig?.stake_button">
                                <div class="amount-sub-box" v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes] : walletConfig?.stake_button)" :key="index">
                                    <button  @click="setStakeValue(stake)" type="button">+{{ stake }}</button>
                                </div>
                            </div>
                            <div class="submit-btn withdraw-btn d-flex gap-2">
                                <a @click="openStackModal" class="editStake">
                                    <img src="@/assets/images/edit-icon.b54a69b8.svg" alt="">
                                    <i class="far fa-edit"></i> {{$t('edit-stake','Edit Stake')}}
                                </a>
                                <a :class="{'disabled-btn' : amount < walletConfig?.deposit_range?.min }" @click="callForDepositMethods()" class="submit_amount_btn">
                                    <span>{{$t('submit', 'Submit')}}</span>
                                </a>
                                
                            </div>
						</form>
					</div>
				</div>
                <WalletInstructions instructionType="deposit" />
                <TutorialVideo v-if="walletConfig?.deposit_video?.English || walletConfig?.deposit_video?.हिन्दी" type = "2"/>
			</div>
	</section>
<WalletStakeModal ref="resetStakeCall" @updateStakes="saveButtonClick" v-if="walletConfig?.stake_button" :stakes="walletConfig?.stake_button" />
</template>

<script>
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import {setWalletStakeValue} from '../services/walletDeposit';
import WalletInstructions from '../components/WalletInstructions.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletStakeModal from '../components/WalletStakeModal.vue';
export default {
    name: 'WalletDeposit',
    inject: ['walletConfig'],
    components: { 
        WalletStakeModal,
        TutorialVideo,
        WalletInstructions,
    },
    data() {
        return {
            walletData: [],
            amount: null,
            loading:false
        }
    },
    computed: {
        minAmount() {
            return this.walletConfig?.deposit_range.min ?? 100;
        },
        maxAmount() {
            return this.walletConfig?.deposit_range.max ?? 99999999;
        },
        ...mapGetters([
            'globalLoader', 'userTransactionStakes'
        ]),
    },
    methods: {
        openStackModal(){
            this.$helper.openModal('#walleteditstackModal');
        },
        callForDepositMethods() {
            if (this.amount == null || this.amount < this.walletConfig?.deposit_range?.min || this.amount > this.walletConfig?.deposit_range?.max) {
                this.$errorToast(`The deposit amount must be between ${this.walletConfig?.deposit_range?.min} and ${this.walletConfig?.deposit_range?.max}.`);
            } else {
                setTimeout(() => {
                    this.$store.dispatch('setDepositAmount', this.amount);
                    this.$router.push({ name: 'deposit-payment-method' });
                }, 300);
            }
        },
        setStakeValue(stake) {
            try {
                const response =  setWalletStakeValue(stake, this.amount, this.walletConfig)
                if(response){
                    this.amount =  response; 
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        saveButtonClick(stakes) {
            this.walletData.stake = stakes;
        },
    }
}
</script>
<style scoped>

</style>